// eslint-disable-next-line no-restricted-imports
import { toast as sonnerToast } from 'sonner'
import { exportToast } from './export-toast'

export const toast = {
  ...sonnerToast,
  export: exportToast,
}
